import axios from "@axios";
import * as ep from "./endpoints";

export default class Service {
  static fetchNgoData() {
    return axios.get(ep.TEMP_NGO_INFO).then((res) => res.data);
  }
  static fetchDocuments() {
    return axios.get(ep.DOCUMENTS).then((res) => res.data);
  }
  static uploadDocument(payload) {
    var toPost = new FormData();
    toPost.append("source", payload.e);
    toPost.append("attachment_id", payload.attachment_id);
    return axios.post(ep.DOCUMENTS, toPost).then((res) => res.data);
  }
  
  static editDocument(payload) {
    var toPost = new FormData();
    toPost.append("source", payload.e);
    toPost.append("_method", "PUT");
    return axios.post(ep.DOCUMENTS_BY_ID(payload.id_edit), toPost).then((res) => res.data);
  }
  static addNgoInfo(payload) {
    return axios.post(ep.NGO_SIGNUP, payload).then((res) => res.data);
  }
  static updateTempAccountInfo(payload) {
    return axios.put(ep.ACCOUNT_INFO, payload).then((res) => res);
  }
  static updateTempNgoInfo(payload) {
    return axios.post(ep.NGO_INFO, payload).then((res) => res);
  }
  static addFounder(payload) {
    var req = new FormData();
    Object.keys(payload).forEach(key => {  
        req.append(`${key}`, payload[key]);
    }); 
    return axios.post(ep.FOUNDERS, req).then((res) => res);
  }
  static updateFounder(payload) {
    var req = new FormData();
    Object.keys(payload.form).forEach(key => {  
        req.append(`${key}`,payload.form[key]);
    }); 
    req.append("_method", "PUT");
    return axios
      .post(ep.FOUNDER_BY_ID(payload.id), req)
      .then((res) => res);
  }
  static deleteFounder(id) {
    return axios.delete(ep.FOUNDER_BY_ID(id)).then((res) => res);
  }
  static addRealEstates(payload) {
    return axios.post(ep.REAL_ESTATES, payload).then((res) => res);
  }
  static updateRealEstates(payload) {
    return axios
      .put(ep.REAL_ESTATES_BY_ID(payload.id), payload.form)
      .then((res) => res);
  }
  static deleteRealEstates(id) {
    return axios.delete(ep.REAL_ESTATES_BY_ID(id)).then((res) => res);
  }
  static AddTransactionRequests(payload) {
    return axios.post(ep.TRANSACTION_REQUESTS_BY_ID, payload).then((res) => res);
  }
  static editTransactionRequests(payload) {
    var req = new FormData();
    req.append("_method", "PUT");
    req.append("slug", "establishing_ngo");
    return axios.post(ep.EDIT_TRANSACTION_REQUESTS_BY_ID(payload.id), req).then((res) => res);
  }
  static fetchLog() {
    return axios.get(ep.LOG).then((res) => res.data);
  }
  static fetchTransaction() {
    return axios.get(ep.TRANSACTION_REQUESTS).then((res) => res.data);
  }
  
  static async changeCurrentStage(payload) {
    return await axios
      .post(ep.CURRENT_STAGE, { finished_stage_number: payload })
      .then((res) => res);
  }
}
